<template>
	<div class="quiz-step">
		<div class="quiz-step__hint">
			{{ props.step.multiple ? 'Можно выбрать несколько' : 'Выберите один вариант' }}
		</div>
		<div class="quiz-step__title">{{ props.step.title }}</div>
		<div class="quiz-step__grid">
			<QuizCard
				v-for="item in props.step.items"
				:key="item.id"
				:item="item"
				:selected="selectedIds.has(item.id)"
				@toggle="emit('toggle', item.id)"
			/>
		</div>
	</div>
</template>

<script setup lang="ts">
import QuizCard from './quiz-card.vue';

interface Props {
	step: QuizStep;
	selectedIds: Set<string>;
}

const props = defineProps<Props>();
const emit = defineEmits<{ toggle: [itemId: string] }>();
</script>